var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-base',{ref:"modal",attrs:{"title":"Entfernen eines Eintrags","okFunction":_vm.okFunction}},[_c('p',[_vm._v("\n    Sind Sie sicher, dass Sie den ausgewählten Eintrag unwiderruflich\n    entfernen möchten?\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }